// extracted by mini-css-extract-plugin
export default {"services-section":"hero_services-section__7D3Pt","relative":"hero_relative__EuXjD"};